import React, { VFC } from 'react'
import { addClassName } from 'utils'

import Img from './Img'

type Props = {
  className?: string
  setIsOpened: React.Dispatch<React.SetStateAction<boolean>>
}

const Header: VFC<Props> = (props) => {
  return (
    <div
      className={`flex justify-end pt-5 pb-[15px] sm:pt-10 sm:pb-[30px] lg:pb-5 ${addClassName(
        props.className
      )}`}
    >
      <div className="w-[18px] h-[18px] sm:w-[36px] sm:h-[36px]">
        <Img
          className="cursor-pointer"
          src="ico-close-1.svg"
          width="36"
          height="36"
          onClick={() => props.setIsOpened(false)}
        />
      </div>
    </div>
  )
}

export default Header
